// Port of api/fuel/app/classes/insights/shelf/recent.php

import Segment from 'offline/insights/segment'

export default Segment.extend({
	name: 'recent',
	requires: ['longest'],
	insight: false,
	run: function(type, owner, userIndex, detail) {
		var recent = []
		var limit = detail ? 1000 : 5
		var played = (this._data.longest || []).slice().sort(function(a, b) {
			return (parseInt(b.played, 10) || 0) - (parseInt(a.played, 10) || 0)
		})

		if (played.length > limit) played = played.slice(0, limit)
		played = played.filter(function(item) { return item.played })

		for (var i = 0; i < played.length; i++) {
			recent.push({
				id: played[i].id,
				date: played[i].played,
				days: Math.floor(played[i].length / 86400)
			})

			this._references.games.push(parseInt(played[i].id, 10))
		}

		return {
			recent: recent
		}
	}
})
